var map = {
	"./8000.gif": "9cc7",
	"./8001.gif": "fe8d",
	"./8002.gif": "4ccb",
	"./8003.gif": "a800",
	"./8004.gif": "e7bb",
	"./8005.gif": "8a15",
	"./8006.gif": "8eaa",
	"./8007.gif": "2159",
	"./8008.gif": "bcae",
	"./8009.gif": "5e7e",
	"./8009_1.gif": "119a",
	"./8010.gif": "4a5d",
	"./8011.gif": "8727c",
	"./8012.gif": "a2ac",
	"./8016.gif": "b746",
	"./default.gif": "6a16"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c9de";